import { useTranslation as useI18nextTranslation } from 'react-i18next'
import { useCallback } from 'react'

export const LANGUAGES = [
  {
    name: 'English',
    flag: '🇺🇸',
    code: 'en',
    urlSuffix: 'en-us',
  },
  {
    name: 'Indonesia',
    flag: '🇮🇩',
    code: 'id',
    urlSuffix: 'id-id',
  },
]

export const useTranslation = (ns = 'common') => {
  const { t, i18n, ready } = useI18nextTranslation(ns)

  const changeLanguage = useCallback(
    async (langCode) => {
      if (!i18n || !langCode) return

      try {
        await i18n.changeLanguage(langCode)
      } catch (error) {
        console.error('Failed to change language:', error)
      }
    },
    [i18n]
  )

  return {
    LANGUAGES,
    t,
    i18n,
    isReady: ready,
    currentLanguage: i18n.language,
    changeLanguage,
  }
}

export default useTranslation
